import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { ApiResponse } from '@shared-models';
import { API_CONFIG, ApiConfig } from '../api-config';

/** Shape API de un contacto/teléfono de customer (GET response / PUT body). */
export interface CustomerContactDto {
  id?: string;
  lada?: string;
  phoneNumber?: string;
  phoneTypeId?: string;
  telephonyId?: string;
  companyId?: string;
  preferred?: boolean;
  /** Alias canónico del backend. */
  primary?: boolean;
}

/** Body de PUT /customers/{id}/contacts */
export type CustomerContactPutPayload = {
  lada: string;
  phoneNumber: string;
  phoneTypeId: string;
  telephonyId: string;
  companyId: string;
  preferred: boolean;
};

/**
 * Contactos/teléfonos del cliente (formulario aparte de domicilios).
 *   GET  /api/customers/{customerId}/contacts
 *   PUT  /api/customers/{customerId}/contacts  (reemplazo total)
 */
@Injectable({ providedIn: 'root' })
export class CustomerContactService {
  private readonly http = inject(HttpClient);
  private readonly apiConfig = inject<ApiConfig>(API_CONFIG);

  private resource(customerId: string): string {
    return `${this.apiConfig.apiUrl}/customers/${customerId}/contacts`;
  }

  getByCustomer(customerId: string): Observable<CustomerContactDto[]> {
    return this.http
      .get<ApiResponse<CustomerContactDto[]>>(this.resource(customerId))
      .pipe(map((res) => (Array.isArray(res.data) ? res.data : [])));
  }

  replaceAll(
    customerId: string,
    contacts: CustomerContactPutPayload[],
  ): Observable<{ message: string; items: CustomerContactDto[] }> {
    return this.http
      .put<ApiResponse<CustomerContactDto[]>>(this.resource(customerId), contacts)
      .pipe(
        map((res) => ({
          message: res.message || 'Contactos actualizados',
          items: Array.isArray(res.data) ? res.data : [],
        })),
      );
  }
}
